import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { FormBuilder } from '@angular/forms';
import { OperacoesAgendadasService } from '../operacoes-agendadas.service';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'ngx-modal-cancel-agendamento',
  templateUrl: './modal-cancel-agendamento.component.html',
  styleUrls: ['./modal-cancel-agendamento.component.scss']
})
export class ModalCancelAgendamentoComponent implements OnInit {

  @Input() id: string;
  @Input() nome: string;
  @Input() cpf: string;
  @Input() matricula: string;

  @ViewChild("card", null)

  private card: ElementRef;
  public formModalCard = null;
  
  constructor(
    private formBuilder: FormBuilder,
    protected ref: NbDialogRef<ModalCancelAgendamentoComponent>,
    private service: OperacoesAgendadasService,
    private notifications: NotificationsService,
  ) {

    this.formModalCard = this.formBuilder.group({
      id: [this.id],
      nome: [null],
      cpf: [null],
      matricula: [null],
    });

  }

  ngOnInit() {
    this.card.nativeElement.ownerDocument.activeElement.blur();
  }

  dismiss(data) {
   
    if (data === true) {

      this.service.cancelAgendamento(this.id, (response) => {   
       
        this.notifications.success("Agendamento Cancelado com sucesso.")        
        this.ref.close();
      }, null)   

    } else {

      this.ref.close();

    }
  }

}
